import React, { forwardRef, useContext } from 'react'

import { cx } from '@linaria/core'
import { Link } from 'react-router-dom'

import { ProfileNextContext } from 'components/block/Profile/ProfileMain/context/ProfileNextContext'
import { ChatSvg } from 'components/designSystem/svgr/ChatSvg'
import { useAuthorized } from 'hooks/useAuthorized'

import { commonCss } from './buttons.styled'
import { iconProps } from './constants'
import { useChatClickHandler } from '../hooks/useChatClickHandler'
import { useChatUrl } from '../hooks/useChatUrl'

export const Chat = forwardRef<HTMLAnchorElement>(({}, ref) => {
  const authorized = useAuthorized()
  const { profileId } = useContext(ProfileNextContext)
  const chatUrl = useChatUrl(profileId!)
  const handleChatClick = useChatClickHandler(profileId!)

  return (
    <Link
      ref={ref}
      to={chatUrl}
      onClick={!authorized ? undefined : handleChatClick}
      data-name="message-action"
      className={cx(commonCss)}
    >
      <ChatSvg {...iconProps} />
    </Link>
  )
})
